<template>
  <transition name="modal">
    <div class="alert-modal" >
      <div class="alert-area">
        <div id="alert_image_overlay">
          <img  style="border-radius:4px" src="@/assets/images/alert.png" class="hidden md:block">
          <img  style="border-radius:4px" src="@/assets/images/mobile-alert.png" class="md:hidden">
          <img @click="closeAlertModal" style="cursor:pointer;" id="close" src="@/assets/images/close.png">
          <p id="alert_header">Not ready <br/>to order?</p>
          <p id="alert_content">Help us understand <br/>your needs!</p>
          <button id="alert_button" class="bg-green-light rounded-full px-4 md:px-6 py-2 text-white text-lg font-medium">Book a Call</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapActions} from 'vuex';
export default {
  name: 'Alert',
  methods: {
    ...mapActions ([ 'openAlertModal' ]),
    closeAlertModal() {
      this.openAlertModal(false)
    } 
  }
}
</script>

<style lang="scss" scoped>
  .alert-modal {
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          content: "";
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
#alert_image_overlay {
  margin: 1em auto;
  border-radius: 8px;
  position: relative;
  color: #024457;
  z-index: 1001;
  @media(max-width: 768px) { 
    border-radius: 0px;
  }
}
#alert_image_overlay #close {
  position: absolute;
  top: 10px;
  right: 90px;
  @media(max-width: 768px) {
    position: absolute;
    top: 12px;
    right: 15px;
  }
}
#alert_image_overlay #alert_header {
  position: absolute;
  top: 40px;
  left: 40px;
  color: #2D2D84;
  font-size: 60px;
  line-height: 60px;
  font-weight: 600;
  font-style: Avenir;
  @media(max-width: 768px) {
    top: 35px;
    left: 20px;
    font-size: 49px;
    line-height: 49px;
    font-weight: 600;
  }

}
#alert_image_overlay #alert_content {
  position: absolute;
  top: 165px;
  left: 40px;
  color: #243943;
  font-size: 24px;
  line-height: 32.78px;
  font-style: Avenir;
  @media(max-width: 768px) { 
    font-size: 20px;
    line-height: 27.32px;
    top: 133px;
    left: 20px;
    font-style: Avenir;
  }

}
#alert_image_overlay #alert_button {
  position: absolute;
  top: 260px;
  left: 40px;
  background-color: #2D2D84;
  color: white;
  font-size: 24px;
  line-height: 40px;
  font-style: Avenir;
  @media(max-width: 768px) { 
    top: 210px;
    left: 20px;
    font-size: 18px;
    line-height: 27px;
  }

}
</style>